import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=af84c4de&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af84c4de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af84c4de')) {
      api.createRecord('af84c4de', component.options)
    } else {
      api.reload('af84c4de', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=af84c4de&scoped=true&", function () {
      api.rerender('af84c4de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2J47z4ZymxpAG/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports